
































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Value } from '../../cablin/value';

@Component
export default class ValueComp extends Vue {
  @Prop() private value!: Value
  private typeName = 'null'
  private vStr = ''
  private vBool = false
  private vNum = 0

  constructor () {
    super()
    switch (typeof this.value) {
    case 'string':
      this.typeName = 'string'
      this.vStr = this.value
      break
    case 'number':
      this.typeName = 'number'
      this.vNum = this.value
      break
    case 'boolean':
      this.typeName = 'boolean'
      this.vBool = this.value
      break
    default:
      this.typeName = 'null'
    }
  }

  updateValue () {
    let retValue: Value = null
    switch (this.typeName) {
    case 'null':
      retValue = null
      break;
    case 'string':
      retValue = this.vStr
      break;
    case 'boolean':
      retValue = this.vBool
      break;
    case 'number':
      retValue = this.vNum
      break;
    default:
      retValue = null
      break;
    }

    this.$emit('input', retValue)
  }
}
